<div>
  <button (click)="click()" type="button"
    class="text-center px-6 py-2 rounded bg-green-600 hover:bg-green-700 text-white">
    {{heading()}}
  </button>
</div>